export const mediaHeroImageDesktop =
  'https://neoterra-site.b-cdn.net/Building%20facade%20-%20Lake%20view%201.jpg';
